// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_cl-3";
export var flatBottomCorners = "_cl-5";
export var productImage = "_cl-0";
export var quantityContainer = "_cl-2";
export var quantityHeader = "_cl-6";
export var tooltip = "_cl-1";
export var wrapAndEllipsesOverflow = "_cl-4";